import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "modal-title text-center w-100 mb-4" };
const _hoisted_2 = { class: "table bg-transparent" };
const _hoisted_3 = {
    class: "bg-transparent",
    scope: "row"
};
const _hoisted_4 = { class: "bg-transparent" };
const _hoisted_5 = { class: "border-top border-2 border-start-0 border-end-0" };
const _hoisted_6 = {
    class: "bg-transparent",
    scope: "row"
};
const _hoisted_7 = { class: "bg-transparent" };
const _hoisted_8 = {
    class: "bg-light text-primary fs-5",
    scope: "row"
};
const _hoisted_9 = { class: "bg-light text-primary fs-5 fw-bold" };
const _hoisted_10 = { class: "bg-light text-primary fs-5 fw-bold" };
const _hoisted_11 = {
    key: 0,
    class: "border-top border-2 border-start-0 border-end-0"
};
const _hoisted_12 = {
    class: "bg-transparent small",
    scope: "row"
};
const _hoisted_13 = { class: "bg-transparent small" };
const _hoisted_14 = { class: "bg-transparent small" };
import { formatters } from '@/Composables/formatters';
import axios from 'axios';
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import ContextModal from '../Components/ContextModal.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ConfigurationPriceComposition',
    props: {
        configurationId: String,
        amount: {
            type: Number,
            default: 100
        }
    },
    setup(__props) {
        const { t } = useI18n();
        let { formatCurrency } = formatters();
        const props = __props;
        const key = ref(Math.random().toString(36).substring(7));
        const modal = ref();
        const singlePrice = ref(0);
        const totalPrice = ref(0);
        const dimensionSheetPrice = ref(0);
        const priceCompositions = ref([]);
        onMounted(() => {
            calculateSinglePrice();
            calculateTotalPrice();
            calculateDimensionSheetPrice();
            calculatePriceCompositions();
            modal.value.open();
        });
        function calculateSinglePrice() {
            axios.post(route('configurator.priceCalculation.getSinglePrice', props.configurationId), {
                amount: props.amount
            })
                .then(function (response) {
                singlePrice.value = response.data;
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function calculateDimensionSheetPrice() {
            axios.post(route('configurator.priceCalculation.getDimensionSheetPrice', props.configurationId), {
                amount: props.amount
            })
                .then(function (response) {
                dimensionSheetPrice.value = response.data;
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function calculateTotalPrice() {
            axios.post(route('configurator.priceCalculation.getTotalPrice', props.configurationId), {
                amount: props.amount
            })
                .then(function (response) {
                totalPrice.value = response.data;
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function calculatePriceCompositions() {
            axios.post(route('configurator.priceCalculation.composition', props.configurationId), {
                amount: props.amount
            })
                .then(function (response) {
                priceCompositions.value = response.data;
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ContextModal, {
                ref_key: "modal",
                ref: modal,
                id: 'configurationPriceOverview-' + key.value,
                size: 'lg'
            }, {
                default: _withCtx(() => [
                    _createElementVNode("h3", _hoisted_1, _toDisplayString(_unref(t)('Ihre Konfiguration')), 1),
                    _createElementVNode("table", _hoisted_2, [
                        _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(priceCompositions.value, (composition) => {
                                return (_openBlock(), _createElementBlock("tr", null, [
                                    _createElementVNode("th", _hoisted_3, _toDisplayString(composition.type), 1),
                                    _createElementVNode("td", _hoisted_4, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(composition.records, (record, index) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                                class: _normalizeClass(["d-block", { 'small ms-3': Number(index) != 0 }])
                                            }, _toDisplayString(record.name), 3));
                                        }), 256))
                                    ]),
                                    _cache[0] || (_cache[0] = _createElementVNode("td", { class: "bg-transparent" }, null, -1))
                                ]));
                            }), 256)),
                            _createElementVNode("tr", _hoisted_5, [
                                _createElementVNode("th", _hoisted_6, _toDisplayString(_unref(t)('Einzelpreis')), 1),
                                _cache[1] || (_cache[1] = _createElementVNode("td", { class: "bg-transparent" }, null, -1)),
                                _createElementVNode("td", _hoisted_7, _toDisplayString(_unref(formatCurrency)(singlePrice.value)), 1)
                            ]),
                            _createElementVNode("tr", null, [
                                _createElementVNode("th", _hoisted_8, _toDisplayString(_unref(t)('Gesamtpreis')), 1),
                                _createElementVNode("td", _hoisted_9, _toDisplayString(props.amount) + "x", 1),
                                _createElementVNode("td", _hoisted_10, _toDisplayString(_unref(formatCurrency)(totalPrice.value)), 1)
                            ]),
                            (dimensionSheetPrice.value > 0)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                                    _createElementVNode("th", _hoisted_12, _toDisplayString(_unref(t)('Maßblatt')), 1),
                                    _createElementVNode("td", _hoisted_13, _toDisplayString(_unref(t)('zzgl. einmalig pro Konfiguration')), 1),
                                    _createElementVNode("td", _hoisted_14, _toDisplayString(_unref(formatCurrency)(dimensionSheetPrice.value)), 1)
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ]),
                _: 1
            }, 8, ["id"]));
        };
    }
});
